var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 57,
    viewBox: "0 0 468 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 13.134 4.13401 10 8 10H460C463.866 10 467 13.134 467 17V49C467 52.866 463.866 56 460 56H8C4.13401 56 1 52.866 1 49V17Z",
    fill: "#0087C0",
    stroke: "#156688",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1H460C463.866 1 467 4.13401 467 8V40C467 43.866 463.866 47 460 47H8C4.13401 47 1 43.866 1 40V8Z",
    fill: "#00B4FF",
    stroke: "#156688",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBtn);
export default __webpack_public_path__ + "static/media/createBtn.07ae1b3ad5336d005bfb8c7fd4a6b19b.svg";
export { ForwardRef as ReactComponent };